import styled from 'styled-components';
import { ResponsiveColumn } from 'components/shared/Layout';

export const StyledResponsiveColumn = styled(ResponsiveColumn)`
  button {
    width: 100%;
  }
`;
